import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=61e77484&scoped=true&"
import script from "./FooterNav.vue?vue&type=script&lang=js&"
export * from "./FooterNav.vue?vue&type=script&lang=js&"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=61e77484&scoped=true&lang=css&"
import style1 from "./FooterNav.vue?vue&type=style&index=1&id=61e77484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e77484",
  null
  
)

export default component.exports